/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type GuaranteeScheme =
  typeof GuaranteeScheme[keyof typeof GuaranteeScheme];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GuaranteeScheme = {
  FSCS: 'FSCS',
  NONE: 'NONE',
} as const;
